<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'SECURITY_SETTINGS' }
  ]"
></breadcrumbs>
<page-header title="SECURITY_SETTINGS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="TWO_FACTOR_AUTH_ENABLED"
        >{{ 'TWO_FACTOR_AUTH_ENABLED' | translate }}</label
      >
      <div class="control">
        <chip
          [checked]="getField(['SECURITY_TWO_FACTOR_AUTH_ENABLED'])"
          (onChange)="
            checkboxChange($event, 'SECURITY_TWO_FACTOR_AUTH_ENABLED')
          "
          [value]="!getField(['SECURITY_TWO_FACTOR_AUTH_ENABLED'])"
        >
          <span
            [translationEditableDirective]="
              getField(['SECURITY_TWO_FACTOR_AUTH_ENABLED'])
                ? 'ENABLED'
                : 'DISABLED'
            "
          >
            {{
              (getField(['SECURITY_TWO_FACTOR_AUTH_ENABLED'])
                ? 'ENABLED'
                : 'DISABLED'
              ) | translate
            }}
          </span>
        </chip>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SECURITY_TWO_FACTOR_AUTH_ENABLED')"
      >
        {{ getError('SECURITY_TWO_FACTOR_AUTH_ENABLED') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="TWO_FACTOR_CODE_LENGTH"
        >{{ 'TWO_FACTOR_CODE_LENGTH' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SECURITY_TWO_FACTOR_CODE_LENGTH"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SECURITY_TWO_FACTOR_CODE_LENGTH'])"
          [ngClass]="{
            'is-danger': hasError('SECURITY_TWO_FACTOR_CODE_LENGTH')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SECURITY_TWO_FACTOR_CODE_LENGTH')"
      >
        {{ getError('SECURITY_TWO_FACTOR_CODE_LENGTH') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="TWO_FACTOR_CODE_VALIDITY_MS"
        >{{ 'TWO_FACTOR_CODE_VALIDITY_MS' | translate }}.</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SECURITY_TWO_FACTOR_CODE_VALIDITY_MS"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SECURITY_TWO_FACTOR_CODE_VALIDITY_MS'])"
          [ngClass]="{
            'is-danger': hasError('SECURITY_TWO_FACTOR_CODE_VALIDITY_MS')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SECURITY_TWO_FACTOR_CODE_VALIDITY_MS')"
      >
        {{ getError('SECURITY_TWO_FACTOR_CODE_VALIDITY_MS') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="INACTIVITY_TIMER_ENABLED"
        >{{ 'INACTIVITY_TIMER_ENABLED' | translate }}</label
      >
      <div class="control">
        <chip
          [checked]="getField(['SECURITY_INACTIVITY_TIMER_ENABLED'])"
          (onChange)="
            checkboxChange($event, 'SECURITY_INACTIVITY_TIMER_ENABLED')
          "
          [value]="!getField(['SECURITY_INACTIVITY_TIMER_ENABLED'])"
        >
          <span
            [translationEditableDirective]="
              getField(['SECURITY_INACTIVITY_TIMER_ENABLED'])
                ? 'ENABLED'
                : 'DISABLED'
            "
          >
            {{
              (getField(['SECURITY_INACTIVITY_TIMER_ENABLED'])
                ? 'ENABLED'
                : 'DISABLED'
              ) | translate
            }}
          </span>
        </chip>
      </div>
      <p class="help is-danger" *ngIf="hasError('twoFactorCodeLength')">
        {{ getError('SECURITY_INACTIVITY_TIMER_ENABLED') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="INACTIVITY_TIMER_VISIBILITY"
        >{{ 'INACTIVITY_TIMER_VISIBILITY' | translate }}</label
      >
      <div class="control">
        <chip
          [checked]="getField(['SECURITY_INACTIVITY_TIMER_DISPLAY'])"
          (onChange)="
            checkboxChange($event, 'SECURITY_INACTIVITY_TIMER_DISPLAY')
          "
          [value]="!getField(['SECURITY_INACTIVITY_TIMER_DISPLAY'])"
        >
          <span
            [translationEditableDirective]="
              getField(['SECURITY_INACTIVITY_TIMER_DISPLAY'])
                ? 'VISIBLE'
                : 'HIDDEN'
            "
          >
            {{
              (getField(['SECURITY_INACTIVITY_TIMER_DISPLAY'])
                ? 'VISIBLE'
                : 'HIDDEN'
              ) | translate
            }}
          </span>
        </chip>
      </div>
      <p class="help is-danger" *ngIf="hasError('twoFactorCodeLength')">
        {{ getError('SECURITY_INACTIVITY_TIMER_DISPLAY') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="INACTIVITY_TIMER_TIMEOUT_MS"
        >{{ 'INACTIVITY_TIMER_TIMEOUT_MS' | translate }}.</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SECURITY_INACTIVITY_TIMER_TIMEOUT_MS"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SECURITY_INACTIVITY_TIMER_TIMEOUT_MS'])"
          [ngClass]="{
            'is-danger': hasError('SECURITY_INACTIVITY_TIMER_TIMEOUT_MS')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SECURITY_INACTIVITY_TIMER_TIMEOUT_MS')"
      >
        {{ getError('SECURITY_INACTIVITY_TIMER_TIMEOUT_MS') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
